"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import "../../api/api";
const InvoiceAbandonerReason = ({
  error,
  isPaymentsNetworkSubmission,
  onChange,
  selectedOption,
  value
}) => {
  if (selectedOption === "duplicate-invoice") {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: "small-12 column", children: [
    /* @__PURE__ */ jsx("label", { children: "Reason" }),
    /* @__PURE__ */ jsx("textarea", { onChange, value }),
    error && /* @__PURE__ */ jsx("div", { className: "alert-box--caution", children: "Please enter a reason" }),
    isPaymentsNetworkSubmission && /* @__PURE__ */ jsx("div", { className: "payments-network__reason", children: "Note: This is a Network Invoice. The factor will be notified that the invoice has been ignored. Please leave a reason." })
  ] });
};
export default InvoiceAbandonerReason;
